<template>
  <el-main id="admin-user">
    <h3 class="section-title green-left-head title-margin">問い合わせ管理</h3>
    <el-table :data="result.docs" stripe style="width: 100%">
      <el-table-column
        prop="category"
        label="カテゴリー"
        width="140"
        :render-header="renderHeader"
      >
        <template slot-scope="scope">
          {{ categoryToStr(scope.row.category) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="ステータス"
        width="140"
        :render-header="renderHeader"
      >
      </el-table-column>
      <el-table-column
        prop="sei"
        label="姓"
        width="80"
        :render-header="renderHeader"
      >
      </el-table-column>
      <el-table-column
        prop="mei"
        label="名"
        width="80"
        :render-header="renderHeader"
      >
      </el-table-column>
      <el-table-column
        prop="mansion.name"
        label="マンション名"
        :render-header="renderHeader"
      >
      </el-table-column>
      <el-table-column prop="roomNo" label="部屋番号" width="120">
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新日"
        width="200"
        :render-header="renderHeader"
      >
        <template slot-scope="scope">
          {{ scope.row.updatedAt | moment("YYYY/MM/DD hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row._id)"
            >編集</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="result.totalDocs"
      :page-size="result.limit"
      @current-change="onCurrentChange"
    >
    </el-pagination>
  </el-main>
</template>

<script>
import authHeader from "../../../services/auth-header";
// import MansionService from "../../../services/mansion.service";
// import UserService from "../../../services/user.service";

import FormAnswerService from "../../../services/form-answer.service";

import Admin from "../../../mixin/guard/admin";

export default {
  mixins: [Admin],
  data() {
    return {
      uploadCSV: `${process.env.VUE_APP_API_ENDPOINT}/v1/user/upload`,
      uploadCSVdb: `${process.env.VUE_APP_API_ENDPOINT}/v1/user/uploaddb`,
      uploadCSVForUpdate: `${process.env.VUE_APP_API_ENDPOINT}/v1/user/upload3`,
      // mansions: [],
      // mansionsDef: [{ code: "", name: "すべて", _id: "" }],
      result: { docs: [] },
    };
  },
  computed: {
    header: function() {
      return authHeader();
    },
    sortCaretAsc: function() {
      return function(prop) {
        if (this.sortProp === prop && this.sortOrder === "asc") {
          return "sort-caret ascending active";
        }
        return "sort-caret ascending";
      };
    },
    sortCaretDesc: function() {
      return function(prop) {
        if (this.sortProp === prop && this.sortOrder === "desc") {
          return "sort-caret descending active";
        }
        return "sort-caret descending";
      };
    },
  },
  async mounted() {
    await this.$nextTick();
    this.find({ page: 1 });
  },
  methods: {
    async sortChange(prop, direction) {
      console.log("sortChange");
      // { field: 'asc', test: -1 }
      const order = {};
      order[prop] = direction;
      console.log(`${prop}/${direction}`);
      await this.find({ page: 1, order });
    },
    renderHeader(h, e) {
      return h("div", null, [
        h("span", { class: "caret-wrapper" }, [
          h(
            "i",
            {
              class: this.sortCaretAsc(e.column.property),
              on: {
                click: () => this.sortChange(e.column.property, 1),
              },
            },
            null,
          ),
          h(
            "i",
            {
              class: this.sortCaretDesc(e.column.property),
              on: {
                click: () => this.sortChange(e.column.property, -1),
              },
            },
            null,
          ),
        ]),
        e.column.label,
      ]);
    },
    categoryToStr(category) {
      const obj = {
        contact: "問い合わせ",
        friend: "お友達",
        order: "申し込み",
      };
      return obj[category];
    },
    onSuccess() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
    onEdit(id) {
      console.log(`edit=${id}`);
      this.$router.push({
        name: "admin-contact-edit",
        params: { id, mc_code: this.currentUser.mansion._id },
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    submitUploaddb() {
      this.$refs.uploaddb.submit();
    },
    async find(query) {
      console.log("+++++ find");
      console.log(query);
      const res = await FormAnswerService.find(query);
      this.result = res.data;
      console.log(this.result);
    },
    async onCurrentChange(page) {
      // console.log(page);
      this.findByDB(this.currentUser.mansion._id, page);
    },
  },
};
</script>

<style>
.el-table .sort-caret.ascending.active {
  border-bottom-color: #409eff;
}
.el-table .sort-caret.descending.active {
  border-top-color: #409eff;
}
</style>
../../../mixin/guard/admin
